import { Link, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { AuthScaffold } from "./Login";

/**
 * There is no public sign-up.
 *
 * HQ-AUTH-REGISTER-001. This page used to render first name, last name, email
 * and password to an anonymous visitor, call supabase.auth.signUp, and then
 * hq_bootstrap_employee — which inserted an hq_employees row for whoever held
 * the new session. Anyone on the internet could become an employee of this
 * company. The page even explained that later signups default to Employee, as
 * though that were the safeguard rather than the problem.
 *
 * HQ has always had the right path: an administrator invites someone, the
 * invite pre-creates their employee record, and accepting it links the two.
 * hq_bootstrap_employee now only ever performs that link and creates nothing.
 *
 * The route is kept rather than deleted so that an old bookmark, or a link in
 * an email from before, explains itself instead of showing "Page not found" —
 * which reads like a fault and invites someone to go looking for another way in.
 */
export function Register() {
  const { session } = useAuth();
  if (session) return <Navigate to="/" replace />;

  return (
    <AuthScaffold>
      <h1 className="mb-1 text-2xl font-bold tracking-tight">Accounts are by invitation</h1>
      <p className="mb-6 text-sm text-gray2">
        HQ accounts are created by an administrator, not by signing up. If you work here and
        cannot get in, ask an admin to send you an invitation — it goes to your work address
        and sets up your account with the right access.
      </p>
      <p className="mb-6 text-sm text-gray2">
        Already have an account but cannot sign in? Use <Link to="/forgot-password" className="text-teal-dark hover:underline">forgot password</Link> —
        it works whether you set a password before or never finished your invite.
      </p>
      <Link to="/login" className="btn w-full btn-lg text-center">Back to sign in</Link>
    </AuthScaffold>
  );
}
